// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".texts__article-title[data-v-faaa571e]{font:400 normal 26px/50px \"Canela\";letter-spacing:2px;color:#001e31;max-width:800px;text-align:center;margin:0 auto}.texts__article-line[data-v-faaa571e]{height:1px;width:115px;background-color:#001e31;margin:50px auto}.texts__article-content[data-v-faaa571e]{margin:90px 140px;max-width:600px}@media (max-width:769px){.texts__article-content[data-v-faaa571e]{margin:90px 0}}", ""]);
// Exports
module.exports = exports;
